import * as yup from 'yup';

const SlotSchema = yup.object().shape({
  selectedDay: yup.string().required('Please select a day').nullable(),
  selectedSlot: yup
    .object()
    .nullable()
    .when('selectedDay', {
      is: (val?: string) => !!val,
      then: yup.object().required('Please select a time').nullable(),
    }),
});

export {SlotSchema};
